import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {UserService} from '../../_services';
import {Router} from '@angular/router';
import {ToastService} from '../../_services/toast.service';
import {Spinner} from '@angular/cli/utilities/spinner';
import {LoadingService} from '../../_services/loading.service';

@Component({
  selector: 'app-why-delete-my-account',
  templateUrl: './delete-my-account.component.html',
  styleUrls: ['./delete-my-account.component.scss']
})
export class DeleteMyAccountComponent {
  constructor(private modal: ModalController,
              public toast: ToastService,
              private router: Router,
              private spinner: LoadingService,
              private userService: UserService) {
  }

  deleteMyAccount() {
    this.spinner.show();
    this.userService.deleteMyAccount()
      .subscribe((data) => {
        this.spinner.hide();
        this.modal.dismiss();
        this.userService.logout();
        this.router.navigate(['./on-boarding']);
      }, (error) => {
        this.spinner.hide();
        this.toast.error('Failed to delete account please contact admin.');
        console.error(error);
      });
  }

  cancel() {
    this.modal.dismiss();
  }
}
